<template>
    <div id="overview">
        <overview-topics-horizontal v-if="horizontal" class="overview-svg" ref="svg"/>
        <overview-topics-vertical v-else class="overview-svg" ref="svg"/>
        <div v-if="hasMounted" :key="`ova-${key}`">
            <align-strategy-animation :delay="0" :interval="10000"/>
            <artificial-intelligence-animation :delay="0" :interval="10000"/>
            <business-intelligence-animation :delay="0" :interval="10000"/>
            <commercial-alignment-animation :delay="0" :interval="10000"/>
            <custom-visuals-animation :delay="0" :interval="10000"/>
            <data-education-animation :delay="0" :interval="10000"/>
            <data-ethics-animation :delay="0" :interval="10000"/>
            <data-science-animation :delay="0" :interval="10000"/>
            <external-data-animation :delay="0" :interval="10000"/>
            <hands-on-animation :delay="0" :interval="10000"/>
            <internal-data-animation :delay="0" :interval="10000"/>
            <perpetuating-innovation-animation :delay="0" :interval="10000"/>
            <privacy-policy-animation :delay="0" :interval="10000"/>
            <security-policy-animation :delay="0" :interval="10000"/>
            <speed-iteration-animation :delay="0" :interval="10000"/>
        </div>
        <call-to-action/>
    </div>
</template>

<script>
import OverviewTopicsHorizontal from '@/assets/svg/overview-annotations-horizontal.svg'
import OverviewTopicsVertical from '@/assets/svg/overview-annotations-vertical.svg'
import { mapState } from 'vuex'
import CallToAction from '@/components/CallToAction'

import animations from '../TopicAnimations'
import { tween } from 'popmotion'

export default {
    components: {
        OverviewTopicsHorizontal,
        OverviewTopicsVertical,
        ...animations,
        CallToAction
    },

    data() {
        return {
            hasMounted: false,
            key: 0
        }
    },

    computed: {
        ...mapState(['layout', 'w', 'h']),

        horizontal() {
            return this.layout === 'horizontal'
        },

        vb() {
            return {
                x: 0,
                y: 0,
                w: this.horizontal ? 3000 : 2000,
                h: this.horizontal ? 2000 : 3000
            }
        },

        e() {
            const p = this.w < 600 ? 24 : 48
            return {
                x: 0,
                y: p,
                w: this.w,
                h: this.h - 2 * p
            }
        },

        position() {
            return {
                w: 1000,
                h: 1000,
                x: this.horizontal ? 1000 : 500,
                y: this.horizontal ? 456 : 1000
            }
        },

        op() {
            return {
                w: 2000,
                h: 2000,
                x: this.horizontal ? 500 : 0,
                y: this.horizontal ? 0 : 500
            }
        },

        scale() {
            const e = this.e,
                vb = this.vb
            const scale_x = e.w / vb.w
            const scale_y = e.h / vb.h
            return Math.min(scale_x, scale_y).toFixed(3)
        },

        translate() {
            const e = this.e,
                vb = this.vb,
                s = this.scale

            const tx = e.x - vb.x * s + (e.w - vb.w * s) / 2
            const ty = e.y - vb.y * s + (e.h - vb.h * s) / 2
            return [tx.toFixed(2), ty.toFixed(2)]
        },

        transform() {
            const [tx, ty] = this.translate
            const s = this.scale

            return `translate(${tx}px, ${ty}px) scale(${s})`
        }
    },

    watch: {
        horizontal() {
            this.$nextTick(() => this.key++)
        },

        transform: 'positionSVG'
    },

    mounted() {
        this.$nextTick(() => (this.hasMounted = true))
        this.positionSVG()
    },

    beforeDestroy() {
        const svg = document.querySelector('svg.venn-container')

        if (this.animation) this.animation.stop()

        svg.style.bottom = 0
        svg.style.top = null

        svg.style.width = null
        svg.style.height = null
        svg.style.transform = null

        svg.style.paddingTop = null
        svg.style.paddingLeft = null
    },

    methods: {
        positionSVG() {
            const svg = document.querySelector('svg.venn-container')
            const e = this.e
            const p = this.position
            const op = this.op

            svg.style.bottom = null
            svg.style.top = 0

            svg.style.transform = this.transform

            if (this.animation) {
                this.animation.stop()
            }

            this.animation = tween({
                from: op,
                to: p
            }).start(({ x, y, w, h }) => {
                svg.style.width = `${w}px`
                svg.style.height = `${h}px`
                svg.style.paddingTop = `${e.y + y}px`
                svg.style.paddingLeft = `${x}px`
            })
        }
    }
}
</script>

<style lang='stylus' scoped>
#overview
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100vh
    box-sizing: border-box
    padding: 24px 0

    @media (min-width: small)
        padding: 48px 0

.overview-svg
    width: 100%
    height: 100%
</style>

